import { useState } from 'react';

import ChooseMethodPage from './modules/ChooseMethodPage';
import SubmissionPage from './modules/SubmissionPage';
import IreneOnboardingCSEvents from '@rental-manager/tracking/OnboardingClickStreamEvents';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

interface Props {
  confirmVerificationCode: ({ phoneNumber, verificationCode }) => Promise<any>;
  currentProperty: ZrmClickstreamListing;
  fromDashboard: boolean;
  onBack: () => void;
  onClose: () => void;
  phoneNumber: string;
  sendVerificationCode: ({ phoneNumber, verificationMethod }) => Promise<any>;
  trackValidationError: () => void;
  user: ZrmClickstreamUser;
}

const PhoneVerificationPage = (props: Props) => {
  const { currentProperty, fromDashboard, phoneNumber, trackValidationError, user } = props;

  const [currentPage, setCurrentPage] = useState('chooseMethodPage');
  const [verificationMethod, setVerificationMethod] = useState('sms');

  const sendVerificationCode = async ({ verificationMethod }): Promise<any> => {
    return props.sendVerificationCode({ phoneNumber, verificationMethod });
  };

  const confirmVerificationCode = async ({ verificationCode }): Promise<any> => {
    return props.confirmVerificationCode({ phoneNumber, verificationCode });
  };

  const onBack = () => {
    if (!fromDashboard) {
      IreneOnboardingCSEvents.emitBackFromOnboardingFlowEvent({
        currentProperty,
        user,
        triggerObject:
          currentPage === 'chooseMethodPage' ? 'phone_verification_choose_method' : 'phone_verification_submission',
      });
    }
    props.onBack();
  };

  const onClose = () => {
    if (!fromDashboard) {
      IreneOnboardingCSEvents.emitExitFromOnboardingFlowEvent({
        currentProperty,
        user,
        triggerObject:
          currentPage === 'chooseMethodPage' ? 'phone_verification_choose_method' : 'phone_verification_submission',
      });
    }
    props.onClose();
  };

  const renderCurrentPage = () => {
    if (currentPage === 'chooseMethodPage') {
      return (
        <ChooseMethodPage
          phoneNumber={phoneNumber}
          verificationMethod={verificationMethod}
          setVerificationMethodSms={() => setVerificationMethod('sms')}
          setVerificationMethodPhone={() => setVerificationMethod('phone')}
          sendVerificationCode={sendVerificationCode}
          goToSubmissionPage={() => setCurrentPage('submissionPage')}
          fromDashboard={fromDashboard}
          onClose={onClose}
          onBack={onBack}
          currentProperty={currentProperty}
          user={user}
        />
      );
    } else if (currentPage === 'submissionPage') {
      return (
        <SubmissionPage
          phoneNumber={phoneNumber}
          verificationMethod={verificationMethod}
          sendVerificationCode={sendVerificationCode}
          confirmVerificationCode={confirmVerificationCode}
          trackValidationError={trackValidationError}
          fromDashboard={fromDashboard}
          onClose={onClose}
          onBack={onBack}
          currentProperty={currentProperty}
          user={user}
        />
      );
    }
    return null;
  };

  return renderCurrentPage();
};

export default PhoneVerificationPage;
